import React from 'react';
import { useTranslation } from 'react-i18next';
import getUsersISOLocale from 'utils/i18n/getUsersISOLocale';
import { Description } from 'components/DescriptionList';
var LastUpdatedDescription = function LastUpdatedDescription(_ref) {
  var lastUpdated = _ref.lastUpdated;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Description, {
    title: t('form_last_updated_colon')
  }, Intl.DateTimeFormat(getUsersISOLocale(), {
    month: 'short',
    year: 'numeric',
    day: 'numeric'
  }).format(lastUpdated || new Date()));
};
export default LastUpdatedDescription;